<template>
    <b-card header="Profile"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="saveProfile()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name" label-for="firstname">
                        <b-form-input
                            id="firstname"
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                            required
                            :disabled="readonly"
                        >
                        </b-form-input>
                        <input-help :form="form" field="firstname" text="Enter your first name."></input-help>
                    </b-form-group>
                    <b-form-group label="Last Name" label-for="lastname">
                        <b-form-input
                            id="lastname"
                            name="lastname"
                            type="text"
                            v-model="form.lastname"
                            required
                            :disabled="readonly"
                            >
                        </b-form-input>
                        <input-help :form="form" field="lastname" text="Enter your last name."></input-help>
                    </b-form-group>
                    <b-form-group v-if="['client', 'caregiver'].includes(user.role_type)">
                        <b-form-checkbox name="adjustment" v-model="form.opt_out" value="1">Opt Out of Communications</b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Email Address" label-for="email">
                        <b-form-input
                            id="email"
                            name="email"
                            type="email"
                            v-model="form.email"
                            :disabled="readonly"
                            >
                        </b-form-input>
                        <input-help :form="form" field="email" text="Enter your email address.  Ex: user@domain.com"></input-help>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-if="user.role_type === 'client'">
                <b-row>
                    <b-col>
                        <p class="h6">Power of Attorney</p>
                        <hr>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-group label="First Name">
                            <b-form-input id="poa_first_name"
                                          v-model="form.poa_first_name"
                                          :disabled="readonly"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Phone">
                            <b-form-input
                                id="poa_phone"
                                v-model="form.poa_phone"
                                :disabled="readonly"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6">
                        <b-form-group label="Last Name">
                            <b-form-input
                                id="poa_last_name"
                                v-model="form.poa_last_name"
                                :disabled="readonly"
                            />
                        </b-form-group>
                        <b-form-group label="Relationship">
                            <b-form-input id="poa_relationship"
                                          v-model="form.poa_relationship"
                                          :disabled="readonly"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col lg="12">
                    <b-button variant="success" type="submit">Save Profile</b-button>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
    import FormatsDates from '../mixins/FormatsDates';

    export default {
        props: {
            'readonly': {
              type: Boolean,
              default: false,
            },
            'client': {},
            'user': {}
        },

        mixins: [FormatsDates],

        data() {
            return {
                form: new Form({
                    firstname: this.user.firstname,
                    lastname: this.user.lastname,
                    email: this.user.email,
                    date_of_birth: (this.user.date_of_birth) ? this.formatDate(this.user.date_of_birth) : '',
                    poa_first_name: this.client.poa_first_name,
                    poa_last_name: this.client.poa_last_name,
                    poa_phone: this.client.poa_phone,
                    poa_relationship: this.client.poa_relationship,
                    opt_out: this.user.opt_out,
                })
            }
        },

        methods: {
            saveProfile() {
                this.form.post('/profile');
            }
        }
    }
</script>
